module.exports = __webpack_public_path__ + "assets/telegramIcon.cdd7c410.svg";